import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { CreateScreeningService } from '../../services/create-screening/create-screening.service';
import { FormField, form } from '@angular/forms/signals';
import { debounceTime, Subject, Subscription, take } from 'rxjs';
import { ImageService } from '../../../../services/image/image.service';
import { ProductService } from '../../../../services/product/product.service';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { TooltipDirective } from '../../../../common/directives/tooltip/tooltip.directive';
import { AddImageComponent } from '../../../../atoms/add-image/add-image.component';
import { S3BucketEnum, ImageTypesEnum } from '../../../../common/general-types/media-assets.dto';
import { LdgImgComponent } from '../../../../atoms/ldg-img/ldg-img.component';

@Component({
  selector: 'screening-basic-info',
  standalone: true,
  imports: [FormField, TooltipDirective, AddImageComponent, LdgImgComponent],
  templateUrl: './basic-info.component.html',
  styleUrl: './basic-info.component.css'
})
export class ScreeningBasicInfoComponent implements OnInit {

  S3Bucket = S3BucketEnum;
  ImageTypes = ImageTypesEnum;

  private subscriptions = new Subscription();
  private productSearchQuerySubject = new Subject<string>();
  productSearchQueryModel = signal({
    query: '',
  })
  productSearchQueryForm = form(this.productSearchQueryModel)
  allProducts = signal<any | undefined>(undefined);
  displayProducts = signal<any | undefined>(undefined);

  displayAdditionalProductImages = signal<string[]>([]);


  /** Services */
  public createScreeningService = inject(CreateScreeningService);
  private productService = inject(ProductService);
  public imageService = inject(ImageService);
  private currentUserService = inject(CurrentUserService);
  /** Services - END */
  

  
  constructor() {
    this.subscriptions.add(
      this.productSearchQuerySubject.pipe(debounceTime(150)).subscribe(query => {
        console.log('query changed:', query);
        this.filterAllProducts(query);
      })
    );

    effect(() => {
      const query = this.productSearchQueryModel().query;
      this.productSearchQuerySubject.next(query);
    });
  }

  ngOnInit(): void {
    this.getBusinessProducts();
  }

  getBusinessProducts() {
    this.productService.getbusinessProducts(this.currentUserService.focussedBrand.id).pipe(take(1)).subscribe((response) => {
      console.log('Products:', response);
      this.allProducts.set(response);
      this.displayProducts.set(response);
    });
  }

  filterAllProducts(query: string) {
    if (query.length > 0) {
      this.displayProducts.set(this.allProducts()?.filter((product: any) => product.productName.toLowerCase().includes(query.toLowerCase())));
    } else {
      this.displayProducts.set(this.allProducts());
    }
  }

  onProductSelect(product: any) {
    this.createScreeningService.selectedProduct.set(product);
  }

  onImageUploaded(event: { file: string, fileKey: string, fullUrl: string }) {
    this.createScreeningService.additionalProductImages.set([...this.createScreeningService.additionalProductImages(), event.fullUrl]);
    this.displayAdditionalProductImages.set([...this.displayAdditionalProductImages(), event.fileKey]);
  }
  
  onImageDelete(image: string) {
    this.createScreeningService.additionalProductImages.set(this.createScreeningService.additionalProductImages().filter((i: string) => i !== image));
    this.displayAdditionalProductImages.set(this.displayAdditionalProductImages().filter((i: string) => i !== image));
  }
}
